import PropTypes from "prop-types";
import React from "react";

const CodingContainer = ({ spaceTopClass, spaceBottomClass, bgClass, img }) => {
  return (
    <div>
      <div
        className={`funfact-area ${spaceTopClass ? spaceTopClass : ""} ${
          spaceBottomClass ? spaceBottomClass : ""
        } ${bgClass ? bgClass : ""}`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-5 col-lg-5 order-1 order-lg-2">
              <div className="funfact-content funfact-res text-center">
                <h2>Coding</h2>
                <div className="timer">
                  <p>
                    At Zebra Robotics, we are passionate about teaching kids how
                    to code. We believe that coding is an essential skill that
                    improves analytical thinking and critical reasoning and
                    opens up a world of opportunities. Kids learn to code from
                    scratch using block-based programming language, Web Design,
                    and they go on to learn Python, which is fundamental for
                    learning AI. Coding for kids is essential for tomorrow.
                  </p>
                </div>
                <div className="funfact-btn funfact-btn--round-shape funfact-btn-red btn-hover">
                  <a href={process.env.PUBLIC_URL + "/locations"}>
                    Choose Location
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-7 order-2 order-lg-1">
              <div className="funfact-image">
                <img
                  src={process.env.PUBLIC_URL + img}
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
CodingContainer.propTypes = {
  bgClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  img: PropTypes.string,
};

export default CodingContainer;
